module.exports = {"pathContext":{"id":"c1Gx1O98yBWgKoY6y8eWmyK","title":"About Me","slug":"about","body":{"id":"c1Gx1O98yBWgKoY6y8eWmyKbodyTextNode","childMarkdownRemark":{"html":"<p>Some quick facts:</p>\n<ul>\n<li>Living in Vancouver, BC with my wife, kid, dog, and two cats</li>\n<li>Made stuff with computers since childhood</li>\n<li>4 years studying interaction design at <a href=\"http://www.sfu.ca/siat.html\">SIAT</a></li>\n<li>13 years working in tech, across design &#x26; engineering roles</li>\n</ul>\n<p>Say hi!</p>"}}}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = 433
// module chunks = 273950069227526